// extracted by css-extract-rspack-plugin
export default {"root":"nT01X","iconWrapper":"a8YnT"};